// fieldInputTtype 3
import React from 'react';
import NumberInputType, { Props } from './NumberInputType';

const CurrencyInputType = (props: Props) => <NumberInputType {...props} hasFixedDecimals={true} />;

export default CurrencyInputType;
